// Copyright © 2019-2026 Focal Systems. All rights reserved.

import { FocalLogoIcon } from "@/components/icons";
import { cn } from "@/lib/utils";

interface InlineSpinnerProps {
  label?: string;
  className?: string;
}

export function InlineSpinner({ label, className }: InlineSpinnerProps) {
  return (
    <div className={cn("flex items-center justify-center gap-2 py-8 text-muted-foreground", className)}>
      <FocalLogoIcon className="h-5 w-5 animate-spinner-pulse" />
      {label && <span className="text-sm">{label}</span>}
    </div>
  );
}
